
function WorkCard({ card, stepNumber }) {
  const title = card.title;
  const description = card.description;
  const imageUrl = card.imageUrl;
  return (

    <div className="h-full max-w-[285px] md:max-w-[324px] bg-white rounded-[3px] shadow-worksShadow relative flex flex-col justify-between">
      <div className=" px-4">
        <div className="absolute -top-6 -left-4 w-12 h-12 rounded-full border-[3px] border-[#454646] bg-white flex items-center justify-center text-[#454646] font-bold text-[24px]">
          {stepNumber}
        </div>

        <div className="mt-3 mb-3.5">
          <h3 className="text-center  text-[18px] md:text-[22px] font-bold text-[#171717]]">{title}</h3>
          <p className="font-medium mt-2 text-[#171717] opacity-80">{description}</p>
        </div>
      </div>

      {/* <div className="mt-6 h-[208px]">
        <div className="relative w-full h-[208px] rounded-br-[3px] rounded-bl-[3px] overflow-hidden">
          <Image
            src={imageUrl}
            alt="Step Illustration"
            fill
            className="object-cover"
            sizes="(max-width: 768px) 100vw, 324px"
          // placeholder="blur"
          // blurDataURL="/images/placeholder.webp" 
          />
        </div>

      </div> */}
    </div>

  )
}

export default WorkCard
